import styled from 'styled-components/native';
import View from '../../elements/View';
const CheckBoxView = styled(View) `
  padding-left: 8px;
  ${props => props.customStyle}
`;
export default CheckBoxView;
